module.exports = require("skypager-util/lib/entity");


//////////////////
// WEBPACK FOOTER
// external "skypager-util/lib/entity"
// module id = 34
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 15 18